import {ModuleWithProviders, NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import * as directives from "./directives";
import * as components from "./components";
import {UserComponent} from "./components";
import * as services from "./services";
import * as pipes from "./pipes";
import * as liteComponent from "./liteComponent";
import * as filterComponent from "./filterComponents";
import {FormsModule, ReactiveFormsModule} from "@angular/forms";
import {RouterModule} from "@angular/router";
import {AlertModalComponent, ConfirmComponent} from "./modals";
import {NgbModule} from "@ng-bootstrap/ng-bootstrap";
import {NgSelectModule} from "@ng-select/ng-select";
import {NgOptionHighlightModule} from '@ng-select/ng-option-highlight';
import {NgxMaskModule} from "ngx-mask";
import {FontAwesomeModule} from "@fortawesome/angular-fontawesome";
import {FileSaverModule} from "ngx-filesaver";
import {UiSwitchModule} from "ngx-ui-switch";
import {CryptographyModule} from "../cryptography";
import { MoveToSendComponent } from './components/move-to-send/move-to-send.component';
import {SaveFileDirective} from "./directives";
import {DateFormatPipe} from "./pipes";
import {UserSessionFilterComponent} from "./filterComponents";
import {YesNoCancelModalComponent} from "./modals/yesNoCancelModal.component";

@NgModule({
  imports: [
    CryptographyModule,
    FontAwesomeModule,
    CommonModule,
    FileSaverModule,
    FormsModule,
    ReactiveFormsModule,
    NgSelectModule,
    NgOptionHighlightModule,
    NgxMaskModule.forRoot(),
    UiSwitchModule.forRoot({
      size: 'medium',
      color: '#ae0000',
    }),
    NgbModule
  ],
  providers: [
    services.AuthGuard,
    services.JwtService,
    services.ResourceService,
    services.ApiService,
    services.AccessRouteGuard,
    services.ValidatorService,
    services.DictionaryService,
    services.IconsService,
    services.UXService,
    liteComponent.FiasService,
    components.AlertPanelService,
    services.VisitedService,
    services.StringDateAdapterService,
    services.GlobalDataProviderService,
  ],
  declarations: [
    components.DatepickerComponent,
    components.DatetimepickerComponent,
    components.AlertPanelComponent,
    components.MultipleFiledComponent,
    components.MultipleFiledDescriptionComponent,
    components.CustomSelectComponent,
    components.CustomSourceSelectComponent,
    components.CustomCheckboxComponent,
    components.JoinedMultiCheckboxComponent,
    components.JoinedMultiSelectComponent,
    components.TableCompComponent,
    components.TableSelectableComponent,
    components.TableEditorComponent,
    components.AlertComponent,
    components.PaginatorComponent,
    components.ScrollBtnComponent,
    components.BigSelectComponent,
    components.BigSelectViewComponent,
    components.GoBackComponent,
    components.SvgIconComponent,
    components.FlkErrorPanelComponent,
    components.SignComponent,
    components.SignSvetoforComponent,
    components.SignElMsgComponent,
    components.DeleteComponent,
    components.UserComponent,
    components.SaveErrorModalComponent,
    directives.ShowAuthDirective,
    directives.CryptCheckStateDirective,
    directives.SortTableDirective,
    directives.AutoFocusDirective,
    directives.AutoFocusFlkDirective,
    directives.ShowElByAccessDirective,
    directives.ConfirmActionDirective,
    directives.InputFormatDirective,
    directives.HighlightDirective,
    directives.MoneyDirective,
    pipes.GetFirstWord,
    pipes.TruncatePipe,
    pipes.CurrencyRubPipe,
    liteComponent.FiasComponent,
    liteComponent.LoadingComponent,
    liteComponent.RqComponent,
    liteComponent.SortComponent,
    liteComponent.ValidComponent,
    liteComponent.AccordionCaretComponent,
    liteComponent.InputFileComponent,
    ConfirmComponent,
    YesNoCancelModalComponent,
    AlertModalComponent,
    filterComponent.DossierFilterComponent,
    filterComponent.CheckClientsFilterComponent,
    filterComponent.NoticeFilterComponent,
    filterComponent.FromuInfoFilterComponent,
    filterComponent.ConsolidatedInfoFilterComponent,
    filterComponent.ConsolidatedListFilterComponent,
    filterComponent.TerroristFilterComponent,
    filterComponent.FromuListFilterComponent,
    filterComponent.RequestsgaUnstrustFilterComponent,
    filterComponent.RiskFactorFilterComponent,
    filterComponent.MvkInfoFilterComponent,
    filterComponent.MvkListFilterComponent,
    filterComponent.BounceRegisterAcceptedFilterComponent,
    filterComponent.BounceRegisterListFilterComponent,
    filterComponent.InternalListFilterComponent,
    filterComponent.Qref281fzListFilterComponent,
    filterComponent.AuditFilterComponent,
    filterComponent.ClientsTransactionsFilterComponent,
    filterComponent.CheckTransactionsFilterComponent,
    filterComponent.SearchInputFilterComponent,
    filterComponent.SubjectComponent,
    filterComponent.RegisterSubjectComponent,
    filterComponent.PassportInfoFilterComponent,
    filterComponent.CommonArchiveFilterComponent,
    MoveToSendComponent,
    directives.SaveFileDirective,
    MoveToSendComponent,
    pipes.DateFormatPipe,
    filterComponent.UserSessionFilterComponent,
    components.UserFormComponent,
    components.ImportDictionaryComponent,
    components.CopyNotificationComponent
  ],
  entryComponents: [
    ConfirmComponent,
    components.TableEditorComponent,
    components.BigSelectViewComponent,
    components.SignComponent,
    components.SignSvetoforComponent,
    components.SignElMsgComponent,
    components.DeleteComponent,
  ],
  exports: [
    FontAwesomeModule,
    components.AlertComponent,
    components.SvgIconComponent,
    components.PaginatorComponent,
    pipes.GetFirstWord,
    pipes.TruncatePipe,
    pipes.CurrencyRubPipe,
    CommonModule,
    FormsModule,
    liteComponent.SortComponent,
    liteComponent.FiasComponent,
    liteComponent.LoadingComponent,
    liteComponent.RqComponent,
    liteComponent.ValidComponent,
    liteComponent.AccordionCaretComponent,
    liteComponent.InputFileComponent,
    ReactiveFormsModule,
    RouterModule,
    directives.SortTableDirective,
    directives.ShowElByAccessDirective,
    directives.ConfirmActionDirective,
    directives.AutoFocusDirective,
    directives.AutoFocusFlkDirective,
    directives.ShowAuthDirective,
    directives.CryptCheckStateDirective,
    directives.InputFormatDirective,
    directives.HighlightDirective,
    directives.MoneyDirective,
    components.DatepickerComponent,
    components.DatetimepickerComponent,
    components.AlertPanelComponent,
    components.MultipleFiledComponent,
    components.MultipleFiledDescriptionComponent,
    components.CustomSelectComponent,
    components.CustomCheckboxComponent,
    components.JoinedMultiCheckboxComponent,
    components.JoinedMultiSelectComponent,
    components.CustomSourceSelectComponent,
    components.TableCompComponent,
    components.TableSelectableComponent,
    components.ScrollBtnComponent,
    components.BigSelectComponent,
    components.GoBackComponent,
    components.FlkErrorPanelComponent,
    filterComponent.DossierFilterComponent,
    filterComponent.CheckClientsFilterComponent,
    filterComponent.NoticeFilterComponent,
    filterComponent.FromuInfoFilterComponent,
    filterComponent.ConsolidatedInfoFilterComponent,
    filterComponent.ConsolidatedListFilterComponent,
    filterComponent.RequestsgaUnstrustFilterComponent,
    filterComponent.TerroristFilterComponent,
    filterComponent.FromuListFilterComponent,
    filterComponent.RiskFactorFilterComponent,
    filterComponent.MvkInfoFilterComponent,
    filterComponent.MvkListFilterComponent,
    filterComponent.BounceRegisterAcceptedFilterComponent,
    filterComponent.BounceRegisterListFilterComponent,
    filterComponent.InternalListFilterComponent,
    filterComponent.Qref281fzListFilterComponent,
    filterComponent.AuditFilterComponent,
    filterComponent.ClientsTransactionsFilterComponent,
    filterComponent.CheckTransactionsFilterComponent,
    filterComponent.SearchInputFilterComponent,
    filterComponent.SubjectComponent,
    filterComponent.RegisterSubjectComponent,
    filterComponent.PassportInfoFilterComponent,
    filterComponent.CommonArchiveFilterComponent,
    SaveFileDirective,
    components.SaveErrorModalComponent,
    UserComponent,
    DateFormatPipe,
    UserSessionFilterComponent,
    components.UserFormComponent,
    components.ImportDictionaryComponent,
    components.CopyNotificationComponent
  ]
})
export class CoreModule {
  /**
   * Для lazy-module создается новый экземпляр сервиса. Данная конструкция необходима что сервис был один на все модули.
   * https://angular.io/guide/singleton-services
   */
  static forRoot(): ModuleWithProviders<CoreModule> {
    return {
      ngModule: CoreModule,
      providers: [
        { provide: services.UserService },
        { provide: services.SharedMenuService },
        { provide: services.TableService }
      ],
    };
  }
}

